import $ from 'jquery';
import Spinner from 'spin.js';

// Maintain a unique ID for each LoadingIndicator instance which is used to
// create unique, per-instance globals. Not that we use more than one... :)
let loadingIndicatorSequence = 0;


/**
 * Handles showing a scroll.js spinner when jscroll is loading a new page.
 */
export class LoadingIndicator {
    constructor() {
        this.id = loadingIndicatorSequence++;
        this.loadingCount = 0;
        this.spinner = new Spinner();
        this.registerGlobalInsertionFunc();
    }

    getGlobalInsertionFuncKey() {
        return '__veInsertSpinner' + this.id;
    }

    getScriptTagId() {
        return 've-spinner-placeholder-' + this.id;
    }

    registerGlobalInsertionFunc() {
        window[this.getGlobalInsertionFuncKey()] = this.insertSpinner.bind(this);
    }

    getScriptTagHtml() {
        return '<script id="ve-spinner-placeholder-' + this.id + '">' +
            'window.' + this.getGlobalInsertionFuncKey() + '();'
            + '</script>';
    }

    getScriptElement() {
        return $('#' + this.getScriptTagId());
    }

    insertSpinner() {
        this.loadingCount++;

        this.spinner.spin();
        this.getScriptElement().replaceWith(this.spinner.el);
    }

    removeSpinner() {
        // Only remove when the reference count hits zero. Required as jscroll
        // fires the callback to mark the end of scrolling after a next scroll
        // has already started.
        if(--this.loadingCount === 0)
            this.spinner.stop();
    }
}



/** WEBPACK FOOTER **
 ** ./js/view/components/jscroll-spin.js
 **/